import styled, {css} from 'styled-components'
import {DialogHeader, DialogBody} from '@components/ui/dialog-atoms/DialogAtoms.tsx'

export const StyledDialogHeader = styled(DialogHeader)(
    () => css`
        border-bottom: none;
    `
)

export const StyledDialogBody = styled(DialogBody)(
    ({theme: {palette, typography, spacing}}) => css`
        gap: ${spacing}px;
        & h3 {
            color: ${palette.neutral[900]};
            ${typography.textXl};
            font-weight: 500;
        }

        & p {
            ${typography.textSm};
            color: ${palette.neutral[900]};
        }
    `
)
